import React, { createContext, useEffect, useState } from "react";
import { useLocalStorage } from "../hooks/storage.hook";
import { BaseProps } from "../models/props";

export const AuthContext = createContext({
  isAuthenticated: false,
  setIsAuthenticated: () => {},
});

export const AuthProvider: React.FC<BaseProps> = ({ children }) => {
  const { getObject } = useLocalStorage();
  const [isAuthenticated, setIsAuthenticated] = useState(!!getObject("token"));

  useEffect(() => {
    checkIsAuthenticated();
  }, [isAuthenticated]);


  const checkIsAuthenticated = () => {
    const token = getObject("token");
    setIsAuthenticated(!!token);
  };

  return ( 
    <AuthContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated: checkIsAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
 